export const DataFormatter = (data, type) => {
  if(data !== null && data !== undefined){
  let tempData = data;
  let count = 0;
  if (tempData.length > 0) {
    tempData.forEach(data => {
      data.addressId = count++;
      data.isAddrExist = true;
    });
  } else if(tempData.length <= 0 && type === "relatedDonor") {
      tempData = [{ name: "", relationship: "", key: 0}]
  }
  return tempData;
}else {
  return null;
}
};
